import SectionOurMethod from './SectionOurMethod';
export default SectionOurMethod;
